export class ResourceProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsEc2",
            "baseName": "awsEc2",
            "type": "AwsEc2Resource",
            "format": ""
        },
        {
            "name": "awsRds",
            "baseName": "awsRds",
            "type": "AwsRdsResource",
            "format": ""
        },
        {
            "name": "awsEksNamespace",
            "baseName": "awsEksNamespace",
            "type": "AwsEksNamespaceResource",
            "format": ""
        },
        {
            "name": "awsDynamoDb",
            "baseName": "awsDynamoDb",
            "type": "AwsDynamoDbResource",
            "format": ""
        },
        {
            "name": "gcpCloudSql",
            "baseName": "gcpCloudSql",
            "type": "GcpCloudSqlResource",
            "format": ""
        },
        {
            "name": "gcpGkeNamespace",
            "baseName": "gcpGkeNamespace",
            "type": "GcpGkeNamespaceResource",
            "format": ""
        },
        {
            "name": "azureAksNamespace",
            "baseName": "azureAksNamespace",
            "type": "AzureAksNamespaceResource",
            "format": ""
        },
        {
            "name": "gcpVmResource",
            "baseName": "gcpVmResource",
            "type": "GcpVmResource",
            "format": ""
        },
        {
            "name": "gcpBigQuery",
            "baseName": "gcpBigQuery",
            "type": "GcpBigQueryResource",
            "format": ""
        },
        {
            "name": "awsEbsVolume",
            "baseName": "awsEbsVolume",
            "type": "AwsEbsVolumeResource",
            "format": ""
        },
        {
            "name": "awsFsx",
            "baseName": "awsFsx",
            "type": "AwsFsxResource",
            "format": ""
        },
        {
            "name": "awsKeyspacesTable",
            "baseName": "awsKeyspacesTable",
            "type": "AwsKeyspacesResource",
            "format": ""
        },
        {
            "name": "awsNeptune",
            "baseName": "awsNeptune",
            "type": "AwsNeptuneResource",
            "format": ""
        },
        {
            "name": "awsEksCluster",
            "baseName": "awsEksCluster",
            "type": "AwsEksClusterResource",
            "format": ""
        },
        {
            "name": "awsAgentCore",
            "baseName": "awsAgentCore",
            "type": "AwsAgentCoreResource",
            "format": ""
        },
        {
            "name": "gcpDisk",
            "baseName": "gcpDisk",
            "type": "GcpDiskResource",
            "format": ""
        },
        {
            "name": "gcpGcs",
            "baseName": "gcpGcs",
            "type": "GcpGcsResource",
            "format": ""
        },
        {
            "name": "azureSapHana",
            "baseName": "azureSapHana",
            "type": "AzureSapHanaResource",
            "format": ""
        },
        {
            "name": "gcpSapHana",
            "baseName": "gcpSapHana",
            "type": "GcpSapHanaResource",
            "format": ""
        },
        {
            "name": "googleWorkspace",
            "baseName": "googleWorkspace",
            "type": "GoogleWorkspaceResource",
            "format": ""
        },
        {
            "name": "microsoft365",
            "baseName": "microsoft365",
            "type": "Microsoft365Resource",
            "format": ""
        },
        {
            "name": "azureEntraId",
            "baseName": "azureEntraId",
            "type": "AzureEntraIdResource",
            "format": ""
        },
        {
            "name": "azureVm",
            "baseName": "azureVm",
            "type": "AzureVmResource",
            "format": ""
        },
        {
            "name": "mongoAtlasCluster",
            "baseName": "mongoAtlasCluster",
            "type": "MongoAtlasClusterResource",
            "format": ""
        },
        {
            "name": "cassandraCluster",
            "baseName": "cassandraCluster",
            "type": "CassandraClusterResource",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceProperties.attributeTypeMap;
    }
    constructor() {
    }
}
